module.exports = __webpack_public_path__ + "images/home.31e9468533740e09a284663723feab1e.svg";